import { Box, Stack, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";

// ----------------------------------------------------------------------

type Props = {
	title: string;
	value: number;
};

export default function SummaryData({ title, value }: Props) {
	const { translate } = useLocales();
	const isDownLg = useResponsive("down", "lg");

	return (
		<Box sx={{ ml: 3 }}>
			<Typography color='text.secondary' fontSize={14} sx={{ mt: -1 }} variant='subtitle1'>
				{translate(title)}
			</Typography>
			<Stack alignItems='center' flexDirection='row' sx={{ mt: 1 }}>
				<Typography variant={isDownLg ? "h3" : "h4"}>{value}</Typography>
			</Stack>
		</Box>
	);
}
